import { DocumentCategory } from "@/hooks/useCorporateDocuments";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { 
  FolderOpen, 
  Users, 
  GraduationCap, 
  FileCheck, 
  Scale, 
  Layers 
} from "lucide-react";

interface CategoryTabsProps {
  selectedCategory: DocumentCategory | 'all';
  onCategoryChange: (category: DocumentCategory | 'all') => void;
  language: string;
}

const categoryConfig: Record<DocumentCategory | 'all', { icon: typeof FolderOpen; labelEn: string; labelFr: string }> = {
  all: { icon: Layers, labelEn: 'All', labelFr: 'Tous' },
  hr: { icon: Users, labelEn: 'HR', labelFr: 'RH' },
  training: { icon: GraduationCap, labelEn: 'Training', labelFr: 'Formation' },
  procedures: { icon: FileCheck, labelEn: 'Procedures', labelFr: 'Procédures' },
  legal: { icon: Scale, labelEn: 'Legal', labelFr: 'Légal' },
  general: { icon: FolderOpen, labelEn: 'General', labelFr: 'Général' },
};

export function CategoryTabs({ selectedCategory, onCategoryChange, language }: CategoryTabsProps) {
  return (
    <Tabs value={selectedCategory} onValueChange={(v) => onCategoryChange(v as DocumentCategory | 'all')}>
      <TabsList className="bg-gray-800/50 border border-gray-700 p-1 h-auto flex-wrap">
        {(Object.keys(categoryConfig) as (DocumentCategory | 'all')[]).map((cat) => {
          const config = categoryConfig[cat];
          const Icon = config.icon;
          return (
            <TabsTrigger
              key={cat}
              value={cat}
              className="data-[state=active]:bg-amber-500 data-[state=active]:text-white text-gray-400 px-3 py-2"
            >
              <Icon className="h-4 w-4 mr-2" />
              {language === 'fr' ? config.labelFr : config.labelEn}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}

export function getCategoryLabel(category: DocumentCategory, language: string): string {
  return language === 'fr' ? categoryConfig[category].labelFr : categoryConfig[category].labelEn;
}

export function getCategoryIcon(category: DocumentCategory) {
  return categoryConfig[category].icon;
}
